<template>
  <div :class="selectClass">
    <label v-if="title != '' && !fillWidth" :for="'select-'+ id">{{ title }}</label>
    <label v-if="title != '' && selectedOptionsModel != '' && fillWidth" :for="'select-'+ id">{{ title }}</label>

    <!-- OPTIONS -->
     <select
      v-if="options"
      :class="selectedOptionsClass"
      :id="'select-'+ id"
      :title="id"
      v-model="selectedOptionsModel"
      :disabled="deanInputSelectDisabled">
      <option value="" disabled>Selecteer {{ title.toLowerCase() }}...</option>
      <option v-for="(item, key) in options" :value="item" :key="key">{{ item }}</option>
    </select>

    <!-- DATA -->
    <label v-if="(selectedDataModel != null) && fillWidth" :for="'select-'+ id">{{ title }}</label>
    <select
      v-if="data"
      :class="selectedDataClass"
      :id="'select-'+ id"
      :title="id"
      v-model="selectedDataModel"
      :disabled="deanInputSelectDisabled">
      <option :value="null" disabled>Selecteer {{ title.toLowerCase() }}...</option>
      <option v-for="(item, key) in data" :value="item" :key="key" :disabled="item.disabled">{{ item.label }}</option>
    </select>

    <!-- EMPTY -->
    <select
      v-if="!data && !options"
      :class="selectedDataClass"
      :id="'select-'+ id"
      :title="id"
      v-model="selectedData"
      :disabled="deanInputSelectDisabled">
      <option :value="null" disabled>Selecteer {{ title.toLowerCase() }}...</option>
    </select>

  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

// COMPONENTS
@Component({})

export default class DeanInputSelect extends Vue {
  // DATA
  public selectedOptionsModel: string = '';
  public selectedDataModel: object | null = null;

  // PROPS
  @Prop() private options?: any[];
  @Prop() private data?: any[];
  @Prop({ default: ''}) private title?: string;
  @Prop({ default: 'deanInputSelect'}) private id?: string;
  @Prop() private small?: boolean;
  @Prop() private number?: boolean;
  @Prop() private fillWidth?: boolean;
  @Prop({ default: false }) private label?: boolean;
  @Prop({ default: '' }) private selectedItem?: string;
  @Prop({ default: null }) private selectedData?: object;
  @Prop({ default: false }) private disabled?: boolean;

  // COMPUTED
  get selectClass() {
    let value = 'dean-select';

    if (this.small) {
      value += ` small`;
    }

    if (this.number) {
      value += ` number`;
    }

    if (this.fillWidth) {
      value += ` fill-width`;
    }

    return value;
  }

  get selectedDataClass() {
    if (this.selectedDataModel === null) {
      return `selected-empty`;
    }
  }

   get selectedOptionsClass() {
    if (this.selectedOptionsModel === '') {
      return `selected-empty`;
    }
  }

  get deanInputSelectDisabled() {
    let value = false;
    if (this.disabled)  {
      value = true;
    }
    return value;
  }

  // OPTIONS MODEL
  @Watch('selectedItem')
  public updateSelectedItem() {
    if (this.selectedItem != null) {
      this.selectedOptionsModel = this.selectedItem;
    } else {
      this.selectedOptionsModel = '';
    }
  }

  @Watch('selectedOptionsModel')
  public selectedOptionsModelChanged() {
    const data = {
      id: this.id,
      selected: this.selectedOptionsModel,
    };

    // if (this.selectedOptionsModel != this.selectedItem) {
    this.$emit('selected-value', data);
    // }
  }

  @Watch('options')
  public updatedOptions() {
    this.updateSelectedItem();
  }

  // DATA MODEL
  @Watch('selectedData')
  public updateSelectedData() {
    if (this.selectedData) {
      this.selectedDataModel = this.selectedData;
    } else {
      this.selectedDataModel = null;
    }
  }

  @Watch('selectedDataModel')
  public selectedDataModelChanged() {
    const data = {
      id: this.id,
      selected: this.selectedDataModel,
    };
    // if (this.selectedDataModel != this.selectedData) {
    this.$emit('selected-value', data);
    // }
  }

  @Watch('data')
  public updatedData() {
    this.updateSelectedData();
  }

  // UPDATE ON MOUNTED
  public mounted() {
    this.updateSelectedItem();
    this.updateSelectedData();
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';


</style>
